import {
  getDeliveryCenterConfig,
  setDeliveryCenterConfig,
} from "../api/DeliveryCenter/deliveryCenter";

const ONBOARDING_CONFIG_KEY = "show_new_user_onboard_modal";

/**
 * Check if user has completed onboarding via delivery center config
 * @returns {Promise<boolean>} - true if onboarding is complete (config === false)
 */
export const hasCompletedOnboarding = async () => {
  try {
    const params = {
      config: ONBOARDING_CONFIG_KEY,
    };

    const { data } = await getDeliveryCenterConfig(params);

    // Config value 'false' means onboarding is complete (modal should NOT show)
    // Config value 'true' or undefined means onboarding should show
    return data[ONBOARDING_CONFIG_KEY] === false;
  } catch (err) {
    console.error("Error checking onboarding status:", err);
    // On error, assume not completed to show modal
    return false;
  }
};

/**
 * Mark onboarding as complete by setting config to false
 * @returns {Promise<void>}
 */
export const markOnboardingComplete = async () => {
  try {
    const data = {
      config: {
        [ONBOARDING_CONFIG_KEY]: false, // false means completed/don't show again
      },
    };

    await setDeliveryCenterConfig(data);
  } catch (err) {
    console.error("Error marking onboarding complete:", err);
    throw err;
  }
};

/**
 * Reset onboarding status (for testing/debugging)
 * @returns {Promise<void>}
 */
export const resetOnboardingStatus = async () => {
  try {
    const data = {
      config: {
        [ONBOARDING_CONFIG_KEY]: true, // true means show modal again
      },
    };

    await setDeliveryCenterConfig(data);
  } catch (err) {
    console.error("Error resetting onboarding status:", err);
    throw err;
  }
};
